import React from 'react';
import Icon from '../../../components/AppIcon';

const TicketStats = ({ stats }) => {
  const statCards = [
    {
      label: 'Total Active',
      value: stats?.totalActive || 0,
      icon: 'Ticket',
      color: 'var(--color-primary)',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'In Progress',
      value: stats?.inProgress || 0,
      icon: 'Clock',
      color: 'var(--color-primary)',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Completed Today',
      value: stats?.completedToday || 0,
      icon: 'CheckCircle',
      color: 'var(--color-success)',
      bgColor: 'bg-success/10'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-4 md:mb-6">
      {statCards?.map((stat, index) => (
        <div
          key={index}
          className="bg-card rounded-xl p-4 md:p-6 border border-border shadow-elevation-1 hover:shadow-elevation-2 transition-smooth"
        >
          <div className="flex items-start justify-between mb-3">
            <div className={`w-10 h-10 md:w-12 md:h-12 ${stat?.bgColor} rounded-lg flex items-center justify-center`}>
              <Icon name={stat?.icon} size={20} color={stat?.color} className="md:w-6 md:h-6" />
            </div>
          </div>
          <div className="text-2xl md:text-3xl font-heading font-semibold text-foreground mb-1">
            {stat?.value}
          </div>
          <div className="text-xs md:text-sm font-caption text-muted-foreground">
            {stat?.label}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TicketStats;